import { getInstance } from "./api";


export const doLogin = async (data) => {
    const api = await getInstance(true,'');
    return api.post('login',data);
}

export const getAdminEvents = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get('/admin/getevents?perPage='+data.perPage+'&curPage='+data.curPage+'&admin_list=1',data);
}

export const getSingleEvent = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get('/admin/getevents?single_record=1&id='+data.id,data);
}

export const storeEvents = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/addevent',data);
}

export const updateEvent = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('/admin/editevent',data);
}

export const deleteEvent = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('/admin/eventdelete',data);
}

export const storeTermsconditions = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('/admin/createeventtermscondition',data);
}

export const verifiEmail = async (data) => {
    const api = await getInstance(true,'');
    return api.post(`emailactivation/${data.actcode}/${data.email}`,{});
}

export const doExhibitorRegister = async (data) => {
    const api = await getInstance(true,'');
    return api.post('register',data);
}

export const getExhibitorList = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/exhibitorlist',data);
}

export const deleteExhibitor = async id => {
    const api = await getInstance(false,'admin');
    return api.get(`admin/delete_exhibitor/${id}`);
}

export const getExhibitorData = async id => {
    const api = await getInstance(false,'admin');
    return api.get(`admin/exhibitor_details/${id}`);
}

export const doExhibitorUpdate = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post(`admin/exhibitor_update`,data);
}
export const getEventList = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.get('admin/getevents?exihibitor_list=1',data);
}

export const exhibitorEventGuideline = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/exhibitoreventguideline',data);
}

export const eventAllApplicationStatus = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/eventapplicationstatus',data);
}

export const viewExhibitorEventGuideline = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/viewexhibitoreventguideline',data);
}

export const exhibitorDetails = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/exhibitordetails',data);
}

export const updatedExhibitorProfile = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/updatedexhibitorprofile',data);
}

export const createBoothDetails = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/createboothdetails',data);
}

export const boothDetailsByEvent = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/boothdetailsbyevent',data);
}

export const artworkCreate = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/artwork/create',data);
}

export const artworkupdate = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/artwork/update',data);
}

export const listArtworkByEvent = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/artwork/list',data);
}

export const createPayment = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/createpayment',data);
}

export const deleteEventApplication = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/deleteeventapplication',data);
}

export const getExhibitorEvents = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.get('/admin/getevents?single_record='+data.single_record+'&id='+data.id);
}

export const getBoothTypePrice = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/getboothtypeprice',data);
}

export const getSignature = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/getsignature',data);
}

export const getApplicantsList = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post(`/admin/view_application/${data.event_id}`,data);
}

export const getDeniedApplicantsList = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post(`/admin/view_denied_application/${data.event_id}`,data);
}

export const userStatusUpdate = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post(`/admin/update_status`,data);
}


export const doChangePassword = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('/admin/changepassword',data);
}

export const doForgotPassword = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('forgotpassword',data);
}

export const doForgotPasswordActivation = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('forgotPasswordActivation/'+data.id ,data);
}

export const getEventExhibitorProfile = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/geteventexhibitorprofile',data);
}

export const createEventExhibitorProfile = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/createeventexhibitorprofile',data);
}

export const getAdminSubscription = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get('/admin/get_subscription?admin_list=1&id='+data.id,data);
}

export const createVirtualBooth = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('exhibitor/create_virtual_booth',data);
}

export const addSubscription= async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/add_subscription',data);
}

export const getSingleSubscription = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get('/admin/get_subscription?single_record=1&id='+data.id,data);
}

export const UpdateSubscription= async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/edit_subscription',data);
}

export const deleteSubscription = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('/admin/delete_subscription',data);
}

export const addExhibitorSubscription= async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/add_exhibitor_subscription',data);
}

export const getAdminSubscriber = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get('/admin/get_admin_subscriber?subscriber_list=1',data);
}

export const programListByEvent = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/programming/programlistbyevent',data);
}

export const getProgramEyeView = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get(`admin/programming/view/${data.program_id}`,data);
}

export const createProgram = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/programming/create',data);
}

export const updateProgram = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/programming/update',data);
}

export const deleteProgram = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get(`admin/programming/delete/${data.id}`,data);

}

export const listArtworkByPayment = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('admin/artwork/dashboard_artwork',data);
}

export const listVirtualBooth = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('exhibitor/list_virtual_booth',data);
}

export const getVirtualBooth = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('exhibitor/get_virtual_booth',data);
}

export const updateVirtualBooth = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('exhibitor/update_virtual_booth',data);
}

export const deleteVirtualBooth = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('exhibitor/delete_virtual_booth',data);
}

export const getAdminApplicantsList = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get(`/admin/get_event_application/${data.exhibitor_id}`,data);
}

export const getEventGallery = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/get_event_gallery',data);
}

export const getEventGalleryById = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get(`admin/get_event_gallery_by_id/${data.review_id}`,data);
}

export const deleteEventGallery = async (data) => {
    const api = await getInstance(false,'admin');
    return api.get(`admin/delete_event_gallery/${data.id}`,data);
}

export const addEventGallery = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post('admin/add_event_gallery',data);
}

export const editEventGallery = async (data) => {
    const api = await getInstance(false,'admin');
    return api.post(`admin/edit_event_gallery/${data.id}`,data);
}

export const doSocialMediaCreate = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/socialmedia/create' ,data);
}

export const doSocialMediaUpdate = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/socialmedia/update/'+data.id, data);
}

export const getSocialMedia = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.get('/admin/socialmedia/socialmedialist/'+data.id);
}

export const doSocialPostCreate = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/socialmedia/addpost/'+data.id, data);
}

export const getSocialPost = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.get('/admin/socialmedia/socialpostlist/'+data.id);
}

export const doSocialPostUpdate = async (data) => {
    const api = await getInstance(false,'exhibitor');
    return api.post('/admin/socialmedia/updatepost/'+data.id, data);
}
